module.exports = __webpack_public_path__ + "media/images/products/category/lead-d7d133211389efeb2e4d5a13c7295516.jpg";